class ProductTemplate {
	getElement (post) {
		const div = document.createElement('div')
		div.innerHTML = this.getHtml(post)
		return div.firstElementChild
	}

	getHtml (post) {
		return /* html */ `
	<div class="col-12">
			<div class = "search-item blog-item-wrapper">
					<a class="blog-title-link" href="${post.link}" title="${post.title}" >
						<h4 class="search-title">${post.title}</h4>
					</a>
					<p class="">${post.text}</p>
				</div>
			</div>
		`
	}
}
const productTemplate = new ProductTemplate()
export {
	ProductTemplate,
	productTemplate
}



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/extensions/com_catalog_search_async/template/ProductTemplate.js